// JavaScript code for acf_blocks/faq-block component
(($) => {

     "use strict";
     if ($(".acf-blocks-faq-block").length === 0) {
         return;
     }
     console.log("acf_blocks/faq-block scripts loaded...");

     $(".accordion-header", ".acf-blocks-faq-block").on("click", function () {
         $(this).next(".accordion-content").slideToggle();
         $(this).toggleClass("active");
     });

})(jQuery);